import React from "react";
import { store } from "react-notifications-component";
import "animate.css";
import "./renderStatusModal.scss";

let defaultProps = {
  insert: "top",
  container: "top-right",
  width: 235,
  animationIn: ["animated", "fadeInDown"],
  animationOut: ["animated", "fadeOutUp"],
  dismiss: {
    duration: 3000,
  },
};
const getContent = (type, faIcon, title, message) => {
  return (
    <div className={`animated fadeIn notification-custom-${type}`}>
      <div className="notification-custom-icon">
        <i className={faIcon} />
      </div>
      <div className="notification-custom-content">
        <h3 className="notification-title">{title}</h3>
        <p className="notification-message">{message}</p>
      </div>
    </div>
  );
};
const renderStatusModal = (success, message = null, duration = null) => {
  const config = {
    success: {
      type: "success",
      title: "Success!",
      faIcon: "fa fa-check-circle",
      defaultMessage: "Case has been updated.",
    },
    error: {
      type: "warning",
      title: "Error!",
      faIcon: "fa fa-exclamation-triangle",
      defaultMessage: "Case was unable to update.",
    },
  };

  const status = success ? "success" : "error";
  const { type, title, faIcon, defaultMessage } = config[status];

  store.addNotification({
    content: getContent(
      type,
      faIcon,
      title,
      !!message ? message : defaultMessage
    ),
    ...defaultProps,
    dismiss: {
      duration: !!duration ? duration : defaultProps.dismiss.duration,
    },
  });
};

export default renderStatusModal;
